'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atSigns = require('./atSigns');

var _atSigns2 = _interopRequireDefault(_atSigns);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validMentionPrecedingChars = require('./validMentionPrecedingChars');

var _validMentionPrecedingChars2 = _interopRequireDefault(_validMentionPrecedingChars);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var validMentionOrList = (0, _regexSupplant2.default)('(#{validMentionPrecedingChars})' + // $1: Preceding character
'(#{atSigns})' + // $2: At mark
'([a-zA-Z0-9_]{1,20})' + // $3: Screen name
'(/[a-zA-Z][a-zA-Z0-9_-]{0,24})?', // $4: List (optional)
{
  validMentionPrecedingChars: _validMentionPrecedingChars2.default,
  atSigns: _atSigns2.default
}, 'g'); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validMentionOrList;
module.exports = exports['default'];